import React from 'react';
import { colors, BigEggHeaderLogo, breakpoints, spacing } from '@chegg-ui/theme';
import { getConfig } from '@chegg-web-tools/config-plugin';
import styled from 'styled-components';

const HeaderEl = styled.header`
  height: 60px;
  border-bottom: 4px solid ${colors.cheggOrange};
  width: 100%;
  background-color: white;
  z-index: 350;

  > div {
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    padding: 0 ${spacing.px24};
    justify-content: space-between;
    align-items: center;
  }
  svg {
    display: block;
    width: 88px;
    height: 30px;
  }

  @media only screen and (max-width: ${breakpoints.md.max}) {
    height: 46px;
    > div {
      padding: 0 ${spacing.px16};
    }
    svg {
      display: block;
      width: 60px;
      height: 20px;
    }
  }
`;

export const Header = ({ baseCheggUrl }: { baseCheggUrl: string }) => {
  return (
    <HeaderEl>
      <div>
        <a href={baseCheggUrl}>
          <BigEggHeaderLogo svgColor={colors.cheggOrange} />
        </a>
      </div>
    </HeaderEl>
  );
};
